module.exports = __webpack_public_path__ + "static/media/HCMM581.bad97888.jpg";